
import { Vue, Component } from 'vue-property-decorator';
import LotteryForm from '../components/LotteryForm.vue';
import TipsPop from '../components/TipsPop.vue';
import Pop from '../components/Pop.vue';
import { isWeiXin, inAppAlertLogin } from '@/common/ts/common';
import { showForm, submitForm } from '../api';
import DrawButton from '../components/DrawButton.vue';

@Component({
  components: {
    LotteryForm,
    TipsPop,
    Pop,
    DrawButton,
  },
})
export default class Home extends Vue {
  showLotteryForm = false;
  show = false;
  msg = '';
  title = '';
  downLoadUrl =
    'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';

  async handleLottery() {
    if (!window.udid) {
      return;
    }

    const token = window.gettoken();
    if (window.udid && (token === 'null' || !token)) {
      inAppAlertLogin();
    }

    const res = (await showForm()) as any;
    if (res.code == 200) {
      this.showLotteryForm = true;
    } else if (res.code == 201) {
      //直接参与抽奖
      this.handleLotterySubmit();
    } else {
      this.title = '活动提示';
      this.msg = res.msg;
      this.show = true;
    }
  }

  async handleLotterySubmit(formData?: any) {
    const res = (await submitForm(formData || {})) as any;
    if (res.code == 200) {
      // 调用抽奖接口
      this.showLotteryForm = false;
      this.title = res.msg.includes('恭喜') ? '恭喜中奖' : '未中奖';
      this.msg = res.msg;
      this.show = true;
    } else {
      this.title = '活动提示';
      this.msg = res.msg;
      this.show = true;
    }
  }

  handleRegister() {
    // 跳转到报名页面
    window.location.href =
      'https://app.klingai.com/cn/activity-zone/brand-activity?id=862459762066743329';
  }
}

